import apiClient from '../api/api';

// TypeScript interfaces
export interface SocialProvider {
  provider_name: string;
  is_active: boolean;
}

export interface PermissionProvider {
  _id: string;
  classical_provider: boolean;
  social_provider: SocialProvider[];
  is_deleted: boolean;
  createdAt: string;
  updatedAt: string;
  __v: number;
  id: string;
}

export interface PermissionProviderResponse {
  success: boolean;
  code: number;
  data: PermissionProvider[];
}

export interface UpdatePermissionProviderData {
  classical_provider: boolean;
  social_provider: SocialProvider[];
}

class PermissionProvidersService {
  private readonly BASE_PATH = '/dms-v2-srv/permission-provider-srv';

  // GET: Fetch permission providers
  async getPermissionProviders(): Promise<PermissionProviderResponse> {
    try {
      const response = await apiClient.get(this.BASE_PATH);
      return response.data;
    } catch (error) {
      console.error('Error fetching permission providers:', error);
      throw error;
    }
  }

  // POST/PUT: Update permission providers
  async updatePermissionProviders(data: UpdatePermissionProviderData): Promise<PermissionProviderResponse> {
    try {
      const response = await apiClient.post(this.BASE_PATH, data);
      return response.data;
    } catch (error) {
      console.error('Error updating permission providers:', error);
      throw error;
    }
  }
}

export const permissionProvidersService = new PermissionProvidersService();
export default permissionProvidersService;